<template>
  <div class="page_taskSysSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="项目名称:">
              <el-select v-model="listQuery.ProjectName" filterable clearable size="small" placeholder="" style="width:180px">
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优先级">
              <el-select filterable v-model="listQuery.Priority" clearable placeholder="" style="width: 180px;" size="small">
                <el-option value="1" label="紧急"></el-option>
                <el-option value="2" label="高"></el-option>
                <el-option value="3" label="中"></el-option>
                <el-option value="4" label="低"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select filterable v-model="listQuery.Status" clearable placeholder="" style="width: 180px;" size="small">
                <el-option value="编辑"></el-option>
                <el-option value="待处理"></el-option>
                <el-option value="完成"></el-option>
                <el-option value="过期"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>

    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 27px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <el-form-item label="任务人:">
            <el-select filterable v-model="listQuery.TaskUserId" clearable placeholder="" style="width: 180px;" size="small">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:">
            <el-date-picker v-model="listQuery.StartTime" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 180px;" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:">
            <el-date-picker v-model="listQuery.EndTime" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 180px;" size="small"></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/staging'}">工作台</el-breadcrumb-item>
          <el-breadcrumb-item>安排任务</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addTask">安排任务</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column prop="projectName" label="所属项目" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="msg2" label="类别" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="msg5" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="msg4" label="优先级" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.msg4 == '1'" style="color: red;font-weight: 600;font-size: 14px;">紧急</span>
              <span v-if="row.msg4 == '4'" style="color: orange;font-weight: 600;font-size: 14px;">高</span>
              <span v-if="row.msg4 == '3'" style="color: blue;">中</span>
              <span v-if="row.msg4 == '2'" style="color: green;">低</span>
            </template>
          </el-table-column>
          <el-table-column prop="msg8" label="任务编号" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taskUser" label="任务人" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.taskUser.length>20">{{getUserName(row.taskUser)}}</span>
              <span v-else>{{row.taskUser}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="通知对象" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.noticeUser.length>20">{{getUserName(row.taskUser)}}</span>
              <span v-else>{{row.noticeUser}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="noticeMethod" label="通知方式" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.noticeMethod=='1' ? '企微' :row.noticeMethod=='2' ? '短信' : '' }}</template>
          </el-table-column>
          <el-table-column prop="msg9" label="任务时限" min-width="300" :show-overflow-tooltip="true" align="center">
            <!-- <template slot-scope="{row}">
              <span v-if="row.taskFromat=='1'">
                <span v-if="row.taskDeadline=='1'">无要求</span>
                <span v-if="row.taskDeadline=='2'">{{`单日任务：T+ ${row.taskDeadline2day}日任务，${row.taskDeadline2Hour}时前完成`}}</span>
                <span v-if="row.taskDeadline=='3'">
                  <span v-if="row.taskDeadline3Type=='1'">{{`多日任务：${row.taskDeadline31StartTime} ~ ${row.taskDeadline31EndTime}，截止${row.taskDeadline31Hour}时前完成`}}，</span>
                  <span v-if="row.taskDeadline3Type=='2'">{{ `多日任务：T+ ${row.taskDeadline32day1}~T+${row.taskDeadline32day2},截止${row.taskDeadline32Hour}时前完成` }}</span>
                </span>
              </span>
              <span v-else-if="row.taskFromat=='2'">
                {{`每${regularlyRepeatingTasks==1?'周' :'月'}第${row.regularlyRepeatingTasksDay}日开始，`}}
                <span v-if="row.regularlyRepeatingTaskCompletewithoutAnyDeadline=='0'">
                  {{ `T+ ${row.regularlyRepeatingTasksAddDay}日${row.regularlyRepeatingTasksHour}时前完成` }}
                </span>
                <span v-else-if="row.regularlyRepeatingTaskCompletewithoutAnyDeadline=='1'">不限日期完成</span>
              </span>
            </template> -->
          </el-table-column>
          <el-table-column prop="taskDes" label="描述" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="220">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small" @click="startTask(row)">启动</el-button>
                <el-button type="text" size="small" @click="sendNotice(row)">通知</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog :title="type == 'add' ? '添加' : '编辑'" :visible.sync="addVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :inline="true" :model="addForm" :rules="rules" class="" label-width="100px" size="small">
        <el-form-item label="任务模板:">
          <el-select v-model="modelId" placeholder="" style="width:300px" filterable clearable @change="changeModel" value-key="id">
            <el-option v-for="(item,index) in modelList" :key="index" :label="item.templateNmae" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目:">
          <el-select v-model="addForm.projectId" size="small" filterable clearable placeholder="" style="width: 300px;" @change="changeObj">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类别:" prop="busiId">
          <el-select v-model="addForm.busiId" placeholder="" style="width:300px" filterable clearable @change="changeBusiId">
            <el-option v-for="(item,index) in busiList" :key="index" :label="item.busiName" :value="item.busiId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="模板名称:" prop="templateNmae">
          <el-input v-model="addForm.templateNmae" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="优先级:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.priority">
              <el-radio label="1">紧急</el-radio>
              <el-radio label="2">高</el-radio>
              <el-radio label="3">中</el-radio>
              <el-radio label="4">低</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="任务描述:">
          <el-input v-model="addForm.taskDes" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input v-model="addForm.task" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="名单附件">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>

        <div>
          <el-form-item label="任务人:">
            <el-radio-group v-model="taskUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="taskUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="taskUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="通知对象:">
            <el-radio-group v-model="noticeUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="noticeUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="noticeUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="通知方式:">
          <el-radio-group v-model="addForm.noticeMethod">
            <el-radio label="1">企微</el-radio>
            <el-radio label="2">短信</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="状态:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.enabled">
              <el-radio label="1">启用</el-radio>
              <el-radio label="2">停用</el-radio>
            </el-radio-group>
          </div>
        </el-form-item> -->

        <div class="info_Item_Title f_form" style="margin-bottom: 10px">
          扩展设置
        </div>
        <div>
          <el-form-item label="任务形式:">
            <el-radio-group v-model="addForm.taskFromat">
              <el-radio label="1">单次任务</el-radio>
              <el-radio label="2">定期重复任务</el-radio>
              <el-radio label="2">多次重复任务</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==1">
          <el-form-item label="任务时限要求:">
            <div class="taskDL">
              <el-radio-group v-model="addForm.taskDeadline">
                <el-radio label="1">无要求</el-radio>
                <el-radio label="2">
                  单日任务： T +
                  <el-input v-model="addForm.taskDeadline2day" size="small" style="width: 80px;"></el-input>
                  日任务，
                  <el-input v-model="addForm.taskDeadline2Hour" size="small" style="width: 80px;"></el-input>
                  时前完成
                </el-radio>
                <el-radio label="3">
                  多日任务：
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="1">
                      <el-date-picker v-model="addForm.taskDeadline31StartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" style="width: 120px;"></el-date-picker>
                      ~
                      <el-date-picker v-model="addForm.taskDeadline31EndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" style="width: 120px;"></el-date-picker>
                      日，截止日
                      <el-input v-model="addForm.taskDeadline31Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;margin-top: 10px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="2">
                      T +
                      <el-input v-model="addForm.taskDeadline32day1" size="small" style="width: 80px;"></el-input>
                      ~ T +
                      <el-input v-model="addForm.taskDeadline32day2" size="small" style="width: 80px;"></el-input>
                      截止日
                      <el-input v-model="addForm.taskDeadline32Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==2" style="padding-left: 80px;">
          <el-form-item label="">
            每
            <el-select v-model="addForm.regularlyRepeatingTasks" placeholder="" style="width:80px">
              <el-option label="周" :value="1"></el-option>
              <el-option label="月" :value="2"></el-option>
            </el-select>
            第
            <el-input v-model="addForm.regularlyRepeatingTasksDay" size="small" style="width: 80px;"></el-input>
            日开始
            <el-radio-group v-model="addForm.regularlyRepeatingTaskCompletewithoutAnyDeadline">
              <el-radio label="0">
                T +
                <el-input v-model="addForm.regularlyRepeatingTasksAddDay" size="small" style="width: 80px;"></el-input>
                日
                <el-input v-model="addForm.regularlyRepeatingTasksHour" size="small" style="width: 80px;"></el-input>
                时前完成
              </el-radio>
              <el-radio label="1">不限日期完成</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="发送通知" :visible.sync="noticeVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="notForm" :model="notForm" :rules="rules" class="" label-width="100px" size="small">
        <el-form-item label="通知对象:">
          <el-radio-group v-model="noticeUser">
            <el-radio label="项目客服">项目客服</el-radio>
            <el-radio label="项目业务员">项目业务员</el-radio>
            <el-radio label="项目管理员">项目管理员</el-radio>
            <el-radio label="指定人员">指定人员</el-radio>
          </el-radio-group>
          <el-select filterable v-model="noticeUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="noticeUser=='指定人员'">
            <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知方式:">
          <el-radio-group v-model="notForm.noticeMethod">
            <el-radio label="1">企微</el-radio>
            <el-radio label="2">短信</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="通知发送时间:">
          <el-radio v-model="notForm.IsNow" :label="true" @input="changeIsNow">现在</el-radio>
          <el-radio v-model="notForm.Isorder" :label="true" @input="changeIsorder"> 预约 T+
            <el-input v-model="notForm.IsOrderDay" size="small" style="width: 80px;"></el-input>
            日
            <el-input v-model="notForm.IsOrderTime" size="small" style="width: 80px;"></el-input>
            时
          </el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noticeVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSendNotice" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          templateNmae: '',
          ProjectName: '',
          TaskUserId: '',
          Priority: '',
          Status: '',
          StartTime: '',
          EndTime: '',
        },
        showDropScreen: -1,
        busiList: [],
        userList: [],
        modelList: [],
        projectList: [], //项目列表
        modelId: '',
        addForm: {
          id: '',
          busiId: '',
          busiName: '', //任务类名
          projectId: null,
          projectName: '',
          templateNmae: '', //模板名称
          priority: '', //优先级存中文 1.紧急 2.高 3中 4 低
          task: 0, //任务数
          taskListUrl: '', //任务名单，上传上来文件 第一列为序号，第二列为记录主键，比如身份证号
          taskDes: 0, //任务描述
          taskUser: '', //任务人：存中文 项目客服 项目业务员 项目管理员 指定人员
          noticeUser: '', //通知对象 ：存中文 项目客服 项目业务员 项目管理员 指定人员
          noticeMethod: '', //通知方式：存中文 1企微,2短信
          enabled: 1, //状态 存中文 1为开启 0为停用
          taskFromat: '', //任务形式，1.单次任务，2.定期重复任务 3.多次重复任务
          taskDeadline: '', //任务时限要求 1.为无要求，2为单日任务 3.多日任务
          taskDeadline2day: '', //任务时限要求 单任务加多少天
          taskDeadline2Hour: '', //任务时限要求 单任务 N时前完成 24小时制
          taskDeadline3Type: '', //多日任务选项 1为上，2为下
          taskDeadline31StartTime: '', //多日任务选项1开始时间
          taskDeadline31EndTime: '', //多日任务选项1结束时间
          taskDeadline31Hour: '', //多日任务 N时前完成 24小时制
          taskDeadline32day1: '', //多日任务选项2 天1
          taskDeadline32day2: '', //多日任务选项2 天2
          taskDeadline32Hour: '', //多日任务选项2 小时
          regularlyRepeatingTasks: '', //定期重复任务 1为周2为月
          regularlyRepeatingTasksDay: '', //定期重复任务N天开始
          regularlyRepeatingTasksAddDay: '', //定期重复任务T+N日
          regularlyRepeatingTasksHour: '', //定期重复任务N时前完成
          regularlyRepeatingTaskCompletewithoutAnyDeadline: '' //定期重复任务 不限日期完成为1 是,为0是
        },
        taskUser: '',
        taskUserList: [],
        noticeUser: '',
        noticeUserList: [],
        addVisible: false,
        isBtnLoading: false,
        noticeVisible: false,
        fileList: [],
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        type: '',
        notForm: {
          Id: '',
          NoticeUser: '',
          NoticeMethod: '',
          IsNow: '',
          Isorder: '',
          IsOrderDay: '',
          IsOrderTime: ''
        },
        rules: {
          noticeUser: {
            required: true,
            message: '请选择通知对象',
            trigger: 'change'
          },
          noticeMethod: {
            required: true,
            message: '请选择通知方式',
            trigger: 'change'
          },
        },
      }
    },
    created() {
      this.getList();
      this.GetAllLowerUserIdList();
      this.getBusiList();
      this.getModelList();
      this.getProList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      getBusiList() {
        let str = `?id=1`
        xz.ArdCurStatGetFun('GetTaskBoardPermcc', str).then(res => {
          if (res.status == 'ok') {
            this.busiList = res.data;
          } else {
            this.busiList = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeObj(val) {
        if (val != null) {
          let item = this.projectList.find(e => e.Projectid == val);
          this.addForm.projectName = item.StrprojectName;
        }
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      //获取下级人员列表
      GetAllLowerUserIdList() {
        let str = `?pageNum=1&pageSize=1000&Username=`
        xz.ArdCurStatGetFun('GetAllLowerUserIdList', str).then(res => {
          if (res.status == 'ok') {
            this.userList = res.data.date;
          } else {
            this.userList = [];
          }
        })
      },
      //获取系统模板列表
      getModelList() {
        let d = {
          pageModel: {
            rows: 1000,
            page: 1,
            orderInput: [],
          },
          templateNmae: ''
        }
        xz.ArdCurStat(d, 'GetTaskTempPageList').then(res => {
          if (res.status === 'ok') {
            res.data.data.forEach((e, index) => {
              // 解析 msg10 的 JSON 字符串
              const parsedMsg10 = JSON.parse(e.msg10);
              delete parsedMsg10.Id;
              // 将对象的所有键首字母转为小写
              const toCamelCase = (obj) => {
                const newObj = {};
                for (const key in obj) {
                  // 首字母转小写，其余保持不变
                  const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                  newObj[newKey] = obj[key];
                }
                return newObj;
              };

              // 转换所有字段首字母为小写
              const lowerCaseKeys = toCamelCase(parsedMsg10);
              const result = {
                ...e,
                ...lowerCaseKeys,
                // 如果不想保留 msg10，可以注释掉下面这行；如果想保留，取消注释
                // msg10: data.msg10
              };
              this.$set(res.data.data, index, result);
              if (index == res.data.data.length - 1) {
                this.modelList = res.data.data;
              }
            });
          } else {
            this.modelList = [];
          }
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.modelList = [];
        });
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetTaskPageList').then(res => {
          if (res.status === 'ok') {
            res.data.data.forEach((e, index) => {
              // 解析 msg10 的 JSON 字符串
              const parsedMsg10 = JSON.parse(e.msg10);
              delete parsedMsg10.Id;
              // 将对象的所有键首字母转为小写
              const toCamelCase = (obj) => {
                const newObj = {};
                for (const key in obj) {
                  // 首字母转小写，其余保持不变
                  const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                  newObj[newKey] = obj[key];
                }
                return newObj;
              };

              // 转换所有字段首字母为小写
              const lowerCaseKeys = toCamelCase(parsedMsg10);
              const result = {
                ...e,
                ...lowerCaseKeys,
                // 如果不想保留 msg10，可以注释掉下面这行；如果想保留，取消注释
                // msg10: data.msg10
              };
              this.$set(res.data.data, index, result);
              if (index == res.data.data.length - 1) {
                this.tableData = res.data.data;
                console.log(this.tableData);
              }
            });
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      addTask() {
        this.type = 'add';
        this.addForm = this.$options.data.call(this).addForm;
        this.fileList = [];
        this.taskUser = '';
        this.noticeUser = '';
        this.taskUserList = [];
        this.noticeUserList = [];
        this.addVisible = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.addForm.taskListUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.addForm.taskListUrl = res;
          } else {
            this.addForm.taskListUrl = ''
          }
        });
      },
      editHandle(row) {
        this.type = 'edit'
        this.addForm = row;
        this.modelId = '';
        if (row.taskUser.length > 20) {
          this.taskUser = '指定人员';
          this.taskUserList = row.taskUser.split(',');
        }
        if (row.noticeUser.length > 20) {
          this.noticeUser = '指定人员';
          this.noticeUserList = row.noticeUser.split(',');
        }
        console.log(row);
        this.isBtnLoading = false;
        this.addVisible = true;
      },
      changeModel(val) {
        let row = this.modelList.find(e => e.id == val);
        this.addForm = JSON.parse(JSON.stringify(row));
        console.log(val, this.modelList, row);
        if (row.taskUser.length > 20) {
          this.taskUser = '指定人员';
          this.taskUserList = row.taskUser.split(',');
        }
        if (row.noticeUser.length > 20) {
          this.noticeUser = '指定人员';
          this.noticeUserList = row.noticeUser.split(',');
        }
        this.addForm.id = '';
        this.isBtnLoading = false;
        this.addVisible = true;
      },
      changeBusiId(val) {
        if (val != null && val) {
          let item = this.busiList.find(e => e.busiId == val);
          this.addForm.busiName = item.busiName;
        }
      },
      confirmAdd() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            if (this.taskUser == '指定人员') {
              if (this.taskUserList.length > 0) {
                this.addForm.taskUser = this.taskUserList.toString();
              } else {
                this.$message.error('请选择任务人指定人员！');
                return
              }
            } else {
              this.addForm.taskUser = this.taskUser;
            }
            if (this.noticeUser == '指定人员') {
              if (this.noticeUserList.length > 0) {
                this.addForm.noticeUser = this.noticeUserList.toString();
              } else {
                this.$message.error('请选择通知对象指定人员！');
                return
              }
            } else {
              this.addForm.taskUser = this.taskUser;
            }
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addForm, 'UpdataTask').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.addVisible = false;
                this.isBtnLoading = false;
                this.$message.success('添加成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //启动
      startTask(row) {
        let str = `?id=${row.id}`;
        xz.ArdCurStatGetFun('StartTask', str).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('操作成功！');
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      delHandle(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'UpdataTask').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('删除成功！')
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //根据ID获取用户名
      getUserName(val) {
        return this.userList
          .filter(user => val.includes(user.userid))
          .map(user => user.username)
          .join('，');
      },
      sendNotice(row) {
        this.notForm = {
          Id: row.id,
          NoticeUser: row.NoticeUser,
          NoticeMethod: row.NoticeMethod,
          IsNow: false,
          Isorder: false,
          IsOrderDay: '',
          IsOrderTime: ''
        }
        if (row.noticeUser.length > 20) {
          this.noticeUser = '指定人员';
          this.noticeUserList = row.noticeUser.split(',');
        }
        this.noticeVisible = true;
      },
      changeIsNow(val) {
        if (val) {
          this.notForm.Isorder = false;
        }
      },
      changeIsorder(val) {
        if (val) {
          this.notForm.IsNow = false;
        }
      },
      confirmSendNotice() {
        if (this.noticeUser == '指定人员') {
          if (this.noticeUserList.length > 0) {
            this.notForm.noticeUser = this.noticeUserList.toString();
          } else {
            this.$message.error('请选择通知对象指定人员！');
            return
          }
        } else {
          this.notForm.taskUser = this.taskUser;
        }
        this.$refs.notForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.notForm, 'SendTaskNotice').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.noticeVisible = false;
                this.isBtnLoading = false;
                this.$message.success('发送成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .timeTitle {
    padding: 0 20px;
  }

  .timeItemTile {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .info_Item_Title {
    line-height: 33px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    margin-right: 100px;
  }

  .f_form {
    border-bottom: 1px solid #ddd;
  }
</style>
<style>
  .page_taskSysSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_taskSysSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_taskSysSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_taskSysSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_taskSysSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_taskSysSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .taskDL .el-radio {
    display: block;
    /* 使每个 radio 元素独占一行 */
    height: 32px;
    line-height: 32px;
  }
</style>